$(function () {
    var price = $('#main-price').val();

    $(document).on("click", ".remove", function () {
        $(this).parent().remove();
        $('#danger').hide();

        let itemNb = $('.stt').length;
        if ($('#type_choice').is(':checked')) {
            itemNb = itemNb - 1;
        }
        checkItemNb(itemNb);
        var maxItem = $('#maxItem').attr('data');
        if (itemNb <= maxItem) {
            $('#danger').hide();
            $('#confirm-register').removeAttr('disabled').removeAttr('style');
        } else {
            $('#danger').show();
            $('#confirm-register').attr('disabled', 'disabled').css('background', '#c3c3c3');
        }
        calculatePrice();
    });

    $("#addnew").click(function (e) {
        var maxItem = $('#maxItem').attr('data');
        let itemNb = $('.stt').length;

        console.log(maxItem);
        console.log(itemNb);
        if ($('#type_choice').is(':checked')) {
            itemNb = itemNb - 1;
        }
        checkItemNb(itemNb);
        if (itemNb < maxItem) {
            $("#firstrow").clone() // copy the #firstrow
                .removeAttr("id")  // remove the duplicate ID
                .removeAttr("style")  // remove the style dispaly none
                .insertBefore("#add-buttom");  // add to the form
            e.preventDefault();

            calculatePrice();
        } else {
            $('#danger').show();
        }
    });

    $("#addExtra").click(function (e) {
        var maxItem = $('#maxItem').attr('data');
        let itemNb = $('.stt').length;

        console.log(maxItem);
        console.log(itemNb);
        if ($('#type_choice').is(':checked')) {
            itemNb = itemNb - 1;
        }
        checkItemNb(itemNb);
        if (itemNb <= maxItem) {
            $("#firstrow").clone() // copy the #firstrow
                .removeAttr("id")  // remove the duplicate ID
                .removeAttr("style")  // remove the style dispaly none
                .insertBefore("#add-buttom");  // add to the form
            e.preventDefault();

            calculatePrice();
        } else {
            $('#danger').show();
        }
    });

    $(document).on('change', '#type_choice', function (e) {
        calculatePrice();

        if ($('#type_choice').is(':checked')) {
            if ($('.group-add-person').length > 1) {
                $('#confirm-register').removeAttr('disabled').removeAttr('style');
            } else {
                $('#confirm-register').attr('disabled', 'disabled').css('background', '#c3c3c3');
            }
        } else {
            $('#confirm-register').removeAttr('disabled').removeAttr('style');
        }

        let itemNb = $('.stt').length;
        if ($('#type_choice').is(':checked')) {
            itemNb = itemNb - 1;
        }

        var maxItem = $('#maxItem').attr('data');
        if (itemNb <= maxItem) {
            $('#danger').hide();
            $('#confirm-register').removeAttr('disabled').removeAttr('style');
        } else {
            $('#danger').show();
            $('#confirm-register').attr('disabled', 'disabled').css('background', '#c3c3c3');
        }
        checkItemNb(itemNb);
    });

    function checkItemNb(itemNb) {
        if (itemNb > 0) {
            $('#confirm-register').removeAttr('disabled').removeAttr('style');
        } else {
            $('#confirm-register').attr('disabled', 'disabled').css('background', '#c3c3c3');
        }
    }

    function calculatePrice() {
        var numItems = $('.stt');
        var type_choice = $('#type_choice').is(':checked');
        var totalItems = type_choice ? (numItems.length - 1) : numItems.length;

        for (let i = 0; i <= totalItems; i++) {
            var stt = i + 1;
            $(numItems[i]).text('#' + stt);
        }

        var total = $('.person-number');
        $(total[0]).text(totalItems);

        var total_price = $('.price-total span');
        $(total_price[0]).text('€' + (totalItems * price).toFixed(2));

        if (type_choice) {
            if ($('.group-add-person').length > 1) {
                $('#confirm-register').removeAttr('disabled').removeAttr('style');
            } else {
                $('#confirm-register').attr('disabled', 'disabled').css('background', '#c3c3c3');
            }
        }
    }

    $('.toggle-other-person').on('click', function (){
        $('#add-other-person-to-waiting-list-form').toggle();
    });
});
